import { render, staticRenderFns } from "./MergeEventModal.vue?vue&type=template&id=4e4d6246&scoped=true&"
import script from "./MergeEventModal.vue?vue&type=script&lang=js&"
export * from "./MergeEventModal.vue?vue&type=script&lang=js&"
import style0 from "./MergeEventModal.vue?vue&type=style&index=0&id=4e4d6246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4d6246",
  null
  
)

export default component.exports